export const environment = {
  production: true,
  limitedUsers: ["shahlin"],
  SENTRY_DSN: '',
  API_URL: 'https://canvas-dev-api.lovethat.design/api/canvas/v1.0/',
  RELEASE_VERSION: '0.3.4.1.2',
  GOOGLE_MAPS_API_KEY: 'AIzaSyBT9nh--XQi6eP9LkY1JY48m3tv340ixcs',
  CHECK_SYNC_TIMEOUT: 10000
};
